
const DATA_NAME = "data-tab-";
const TAB_NUMBER_NAME = DATA_NAME+"number";

class TabArea {
  constructor($el, number) {
    this.$el = $el;
    this.$el.attr({[TAB_NUMBER_NAME]:number});
    this.triggersArr = [];
  }
  pushTrigger(trigger){
    this.triggersArr.push(trigger);
  }
  hideTrigger(notTrigger) {
    this.triggersArr.forEach(trigger =>{
      if(notTrigger !== trigger){
        trigger.hide();
      }
    });
  }
  showFirstTrigger(){
    this.triggersArr.forEach((trigger,index) => {
      if(index == 0){
        trigger.show();
      }
    });
  }
}

class TabTrigger {
  constructor($el) {
    this.$el = $el;
    this.controlID = this.$el.attr('aria-controls');
    this.$control = $('#' + this.controlID);
    this.$el.attr({'aria-selected':false,'aria-expanded': false});
    this.$control.attr({'aria-hidden':true});
    this.setEvent();
  }
  set area(area) {
    this._area = area;
  }
  get area(){
    return this._area;
  }
  setEvent(){
    this.$el.on({
      'click' : event => {
        event.preventDefault();
        this.show();
      }
    });
  }
  show() {
    this.area.hideTrigger(this);
    this.$el.attr({'aria-selected':true,'aria-expanded': true});
    this.$control.attr({'aria-hidden':false});
  }
  hide() {
    this.$el.attr({'aria-selected':false,'aria-expanded': false});
    this.$control.attr({'aria-hidden':true});
  }
}

class TabControl {
  constructor(className) {
    this.className = className;
    this.area = $('.'+className);
    this.trigger = $('.'+this.className+'-trigger');
    this.areaList = [];
    this.initArea();
    this.initTrigger();
    this.show();

  }
  initArea(){
    this.area.each((index, element) => {
      let number,area;
      number = index + 1;
      area = new TabArea($(element),number);
      this.areaList.push({number: number,area:area});
    });
  }
  initTrigger(){
    this.trigger.each((index, element) => {
      let trigger,areaNumber,areaData;
      trigger = new TabTrigger($(element));
      areaNumber = $(element).closest('.'+this.className).attr(TAB_NUMBER_NAME);
      areaData = this.getArea(areaNumber);
      areaData.area.pushTrigger(trigger);
      trigger.area = areaData.area;
    });
  }
  show(){
    this.areaList.forEach(element => {
      element.area.showFirstTrigger();
    });
  }
  getArea(number){
    return this.areaList.find(element => {
      return element.number == number;
    });
  }
}

new TabControl('js-tab');
